<section class="faq-section container py-5" #faqSection [class.start-animation]="isVisible">

  <!-- Section Heading -->
  <div class="row justify-content-center text-center mb-5">
    <div class="col-lg-12">
      <h2 class="section-heading">Frequently Asked Questions</h2>
    </div>
  </div>

  <div class="row align-items-center">

    <!-- LEFT COLUMN: Accordion List -->
    <div class="col-lg-6 mb-5 mb-lg-0">
      <div class="faq-list">
        <div class="faq-item" *ngFor="let item of faqList; let i = index" [class.active]="activeIndex === i"
          (click)="toggleAccordion(i)" [style.--i]="i">

          <div class="faq-header">
            <span class="question-text">{{ item.question }}</span>
            <div class="icon-wrapper">
              <span class="plus-icon" *ngIf="activeIndex !== i">+</span>
              <span class="plus-icon" *ngIf="activeIndex === i">-</span>
            </div>
          </div>

          <div class="faq-body" *ngIf="activeIndex === i" [innerHTML]="item.answer"></div>
        </div>
      </div>
    </div>

    <!-- RIGHT COLUMN: Single 3D Card -->
    <div class="col-lg-6">
      <div class="faq-image-container" #tiltContainer>
        <!-- Single Card Wrapper -->
        <div class="image-card">
          <img [src]="'assets/gallery-page/life-at-kalpita/virtual.png'" alt="FAQ Visual" class="img-fluid">
        </div>
      </div>
    </div>

  </div>
</section>